import { LitElement, html } from 'lit';
import { style } from './offer-header-message.style.js';
import '@cof/fs-typography-wc/fs-heading.js';
import '@cof/fs-typography-wc/fs-body-text.js';

class OfferHeaderMessage extends LitElement {
  constructor() {
    super();
    this.message = '';
    this.heading = '';
  }

  static properties = {
    message: { attribute: true },
    heading: { attribute: true },
  };

  static styles = [style];

  render() {
    return html`
      <div class="message-container" role="alert">
        <fs-heading class="title-text hdr" level="1" size="large" data-e2e-ref="offerHeading">${this.heading}</fs-heading>
        <fs-body-text size="normal" class="txt" data-e2e-ref="offerMessage">${this.message}</fs-body-text>
      </div>
    `;
  }
}

customElements.define('offer-header-message', OfferHeaderMessage);
